import { render, staticRenderFns } from "./ITCR.vue?vue&type=template&id=b827d394"
import script from "./ITCR.vue?vue&type=script&lang=js"
export * from "./ITCR.vue?vue&type=script&lang=js"
import style0 from "./ITCR.vue?vue&type=style&index=0&id=b827d394&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports